<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app">
            <v-app id="inspire">
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-card v-model="show">
                        <v-toolbar dark color="blue">
                            <v-toolbar-title>Planilla de Desempeño Proveedor Interno (EI 141)</v-toolbar-title>
                            <v-spacer></v-spacer>
                            Código: {{ codgral }}
                            <v-spacer></v-spacer>
                            <div>
                                <v-btn icon @click="show = false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </div>
                        </v-toolbar>
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="6" sm="6" md="4">
                                    <v-text-field required :rules="requiredRules" label="Proveedor Interno Evaluado"
                                        dense v-model="proveedor"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="4">
                                    <v-text-field required :rules="requiredRules" label="Cliente Interno Evaluador"
                                        dense v-model="cliente"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <v-text-field required :rules="requiredRules" label="Fecha" dense
                                        v-model="fecha"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <v-text-field required :rules="requiredRules" label="Período a evaluar" dense
                                        v-model="periodo" @change="cargarDatos"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense>

                                <v-col cols="6" sm="6" md="3">
                                    <v-text-field label="Proceso" dense v-model="proceso">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" sm="3" md="3">
                                    <v-text-field label="Fecha Evaluación anterior" dense v-model="fechaulteval">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" sm="3" md="3">
                                    <v-text-field label="Puntaje Evaluación anterior" dense v-model="puntajeulteval">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6" sm="3" md="3">
                                    <v-text-field label="Puntaje Presente Evaluación" dense v-model="puntajepreseval">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card>
                        <v-card-text>
                            <template>
                                <div>
                                    <table class="table">
                                        <tr>
                                            <td colspan="6">
                                                <b>Instrucciones:</b> Evalúe cuidadosamente el desempeño en el trabajo
                                                del
                                                proveedor interno, de acuerdo a los requerimientos del cliente interno.
                                                Asigne puntaje de calificación a cada factor evaluado, de acuerdo al
                                                nivel
                                                de escala, e indíquelo en el cuadro de puntuación correspondiente. Se
                                                sumará
                                                el
                                                total de puntos, y se calculará el promedio para una calificación de
                                                desempeño global.
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="6" align="center"><b>IDENTIFICACIÓN DE LA CALIFICACIÓN</b></td>
                                        </tr>
                                        <tr>
                                            <td colspan="2" align="center"><b>Insuficiente</b></td>
                                            <td align="center"><b>Regular</b></td>
                                            <td align="center"><b>Bueno</b></td>
                                            <td align="center"><b>Muy Bueno</b></td>
                                            <td align="center"><b>Excelente</b></td>
                                        </tr>
                                        <tr>
                                            <td colspan="2" align="center"><b>0 &#8804; n &lt; 3</b></td>
                                            <td align="center"><b>3 &#8804; n &lt; 5</b></td>
                                            <td align="center"><b>5 &#8804; n &lt; 7</b></td>
                                            <td align="center"><b>7 &#8804; n &lt; 9</b></td>
                                            <td align="center"><b>9 &#8804; n &#8804; 10</b></td>
                                        </tr>
                                    </table>
                                    <table border="2" cellpadding="0" cellspacing="2" width="100%" id="AutoNumber2">
                                        <thead>
                                            <tr>
                                                <td colspan="2" width="65%" align="center"><b>Factores</b></td>
                                                <td width="10%" align="center"><b>Calificación</b></td>
                                                <td width="55%" colspan="2" align="center"><b>Detalle o comentario de
                                                        apoyo</b>
                                                </td>
                                            </tr>
                                            <tr v-for="(tableData, index) in factors" :id="index">
                                                <td width="65%" colspan="2" style="margin: 0">
                                                    {{ factors[index].text }}
                                                </td>
                                                <td width="10%" align="center" style="margin: 0"><v-text-field dense
                                                        outlined v-model="factors[index].calificacion"
                                                        @change="calcularvalor()"></v-text-field></td>
                                                <td width="25%" align="center" colspan="2" style="margin: 0"><v-textarea
                                                        dense outlined rows="1" v-model="factors[index].detalle"
                                                        auto-grow></v-textarea></td>
                                            </tr>

                                            <tr>
                                                <td width="65%" colspan="2" style="margin: 0">
                                                    Calificación de desempeño global
                                                </td>
                                                <td width="10%" align="center" style="margin: 0"><v-text-field dense
                                                        outlined v-model="puntajeGlobal"></v-text-field></td>
                                                <td width="25%" align="center" colspan="2" style="margin: 0"></td>
                                            </tr>


                                        </thead>
                                    </table>
                                </div>
                            </template>
                        </v-card-text>
                    </v-card>
                    <v-card color="blue" dark tile>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-app>
        </div>
    </v-dialog>

</template>
<style lang="scss">
.v-input--radio-group__input {
    label {
        margin: 0 !important;
    }
}
</style>
<style scoped>
.font-class-name {
    font-size: 14px;
}

.educacion {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
}

.educacion__niveles {
    border: solid 1px;
    list-style: none;
}
</style>
<script>
import moment from "moment";
import axios from "../../../../src/axios-auth";
export default {
    data: (vm) => ({
        usuario: "",
        valid: false,
        lazy: false,
        requiredRules: [(v) => !!v || "Dato obligatorio"],
        fecha: moment().format("DD/MM/YYYY"),
        //periodo: "2024",
        proveedor: "",
        cliente: "",
        //codgral: "",
        periodo: moment().subtract(1, "year").year(),
        periodobase: "",
        proceso: "",
        listadoperiodo: [],
        fechaulteval: "",
        puntajepreseval: "",
        puntajeulteval: "",
        calificaciones: [],
        factors: [
            { text: '1. Entrega en término: Información, producto o servicio.', colspan: 3, colspan2: 2, calificacion: '', detalle: '' },
            { text: '2. Calidad de la entrega: Información suficiente, servicio eficaz, producto adecuado.', colspan: 3, colspan2: 2, calificacion: '', detalle: '' },
            { text: '3. Confiabilidad: Certeza en lo informado, realizado o entregado, que evita demoras.', colspan: 3, colspan2: 2, calificacion: '', detalle: '' },
            { text: '4. Calidad de la comunicación:  Respuesta ágil, precisa y eficiente.', colspan: 3, colspan2: 2, calificacion: '', detalle: '' },
            { text: '5. Predisposición a la reducción de tiempos / costos: Existencia de no conformidades que originaron perjuicios económicos.', colspan: 3, colspan2: 2, calificacion: '', detalle: '' },
            { text: '6. Aceptación de sugerencias: (Modificaciones, agregados que mejoren el desempeño del cliente interno).', colspan: 3, colspan2: 2, calificacion: '', detalle: '' },
            { text: '7. Otras: Describir.', colspan: 3, colspan2: 2, calificacion: '', detalle: '' },
        ],
        puntajeGlobal: "",
        direccion: "",
        correos: "",
        direcciones: [],
        mail: "",
        deshabilitar: false,
    }),
    props: ["codgral", "visible"],
    watch: {
    },
    computed: {

        show: {
            get() {
                if (this.visible == true) {
                    this.cargarListadoMail();
                    this.cargarDatos();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarListado();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },
    methods: {

        cargarListadoMail() {
            let self = this;
            axios
                .get("/Icssa/GetMail?")
                .then((response) => {
                    self.direcciones = response.data;
                })
                .catch((error) => {
                    self.direcciones = [];
                    console.log(error);
                });
        },
        botonMail() {
            this.direccion = this.direccion + this.correos.mail + ";";
        },
        cargarDatos() {
            let self = this;

            axios
                .get("/RRHH/CargarPlanillaDesempenioProve", {
                    params: {
                        codgral: self.codgral,
                        periodo: self.periodo,
                    },
                })
                .then((response) => {
                    self.periodobase = response.data.periodo;
                    if (response.data.periodo == self.periodo) {
                        self.fechaulteval = response.data.fechaulteval;
                        self.puntajeulteval = response.data.puntajeulteval;
                        self.puntajepreseval = response.data.puntajepreseval;
                    }
                    else {
                        self.fechaulteval = response.data.fecha;
                        self.puntajeulteval = response.data.puntajepreseval;
                        self.puntajepreseval = "";
                    }
                    self.proceso = response.data.proceso;
                    self.cliente = response.data.cliente;
                    self.proveedor = response.data.proveedor;
                    self.factors[0].calificacion = response.data.calif1
                    self.factors[1].calificacion = response.data.calif2
                    self.factors[2].calificacion = response.data.calif3
                    self.factors[3].calificacion = response.data.calif4
                    self.factors[4].calificacion = response.data.calif5
                    self.factors[5].calificacion = response.data.calif6
                    self.factors[6].calificacion = response.data.calif7
                    self.factors[0].detalle = response.data.observ1
                    self.factors[1].detalle = response.data.observ2
                    self.factors[2].detalle = response.data.observ3
                    self.factors[3].detalle = response.data.observ4
                    self.factors[4].detalle = response.data.observ5
                    self.factors[5].detalle = response.data.observ6
                    self.factors[6].detalle = response.data.observ7
                    self.puntajeGlobal = response.data.puntajepreseval

                })
                .catch((error) => {

                    console.log(error);
                });
        },

        calcularvalor() {
            var total = 0
            var totalprom = 0
            var cantidad = 0
            if (this.factors.length > 0) {
                console.log("CALCULA")
                this.factors.forEach(element => {
                    if (element.calificacion != "" && element.calificacion != null) {
                        cantidad = cantidad + 1;
                        total = total + (parseFloat(element.calificacion.toString().replace(',', '.')));
                        console.log(cantidad)
                    }
                })
            }
            totalprom = (total / cantidad).toFixed(2);
            this.puntajeGlobal = totalprom.toString().replace('.', ',');
            this.puntajepreseval = totalprom.toString().replace('.', ',');
        },

        vaciarListado() {


            //this.fecha = "";
            //this.periodo = "";
            this.cliente = "";
            this.proveedor = "";
            this.direccion = "";
            this.proceso = "";
            this.factors = [
                { text: '1. Entrega en término: Información, producto o servicio.', colspan: 3, colspan2: 2, calificacion: '', detalle: '' },
                { text: '2. Calidad de la entrega: Información suficiente, servicio eficaz, producto adecuado.', colspan: 3, colspan2: 2, calificacion: '', detalle: '' },
                { text: '3. Confiabilidad: Certeza en lo informado, realizado o entregado, que evita demoras.', colspan: 3, colspan2: 2, calificacion: '', detalle: '' },
                { text: '4. Calidad de la comunicación:  Respuesta ágil, precisa y eficiente.', colspan: 3, colspan2: 2, calificacion: '', detalle: '' },
                { text: '5. Predisposición a la reducción de tiempos / costos: Existencia de no conformidades que originaron perjuicios económicos.', colspan: 3, colspan2: 2, calificacion: '', detalle: '' },
                { text: '6. Aceptación de sugerencias: (Modificaciones, agregados que mejoren el desempeño del cliente interno).', colspan: 3, colspan2: 2, calificacion: '', detalle: '' },
                { text: '7. Otras: Describir.', colspan: 3, colspan2: 2, calificacion: '', detalle: '' },
            ];
            this.puntajeGlobal = "";
            this.fechaulteval = "";
            this.puntajepreseval = "";
            this.puntajeulteval = "";
            this.deshabilitar = false;
            //this.$router.push({ name: "MainRRHH" });
        },

        guardar() {
            this.$swal({
                title: "Guardar Planilla de Desempeño",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    this.deshabilitar = true;
                    this.calificaciones = this.factors

                    var datos = {
                        codgral: this.codgral,
                        cliente: this.cliente,
                        proveedor: this.proveedor,
                        fecha: this.fecha,
                        periodo: this.periodo,
                        proceso: this.proceso,
                        mail: this.mail,
                        puntajepreseval: this.puntajeGlobal,
                        puntajeulteval: this.puntajeulteval,
                        fechaulteval: this.fechaulteval,
                        calif1: this.calificaciones[0].calificacion,
                        calif2: this.calificaciones[1].calificacion,
                        calif3: this.calificaciones[2].calificacion,
                        calif4: this.calificaciones[3].calificacion,
                        calif5: this.calificaciones[4].calificacion,
                        calif6: this.calificaciones[5].calificacion,
                        calif7: this.calificaciones[6].calificacion,
                        observ1: this.calificaciones[0].detalle,
                        observ2: this.calificaciones[1].detalle,
                        observ3: this.calificaciones[2].detalle,
                        observ4: this.calificaciones[3].detalle,
                        observ5: this.calificaciones[4].detalle,
                        observ6: this.calificaciones[5].detalle,
                        observ7: this.calificaciones[6].detalle,

                    };

                    let self = this;
                    axios
                        .post("/RRHH/GuardarPlanillaDesempenioProve", datos)
                        .then((response) => {
                            self.$refs.form.resetValidation();
                            self.vaciarListado();
                            self.showAlert({
                                icon: "success",
                                title: "Planilla guardada con éxito",
                                vm: self,
                            });
                            self.$emit("close");
                        })
                        .catch({});
                } else {
                }
            });
        },
        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },
    },
};
</script>
